import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FoodsView from '../views/FoodsView'
import FoodsDetail from '../views/FoodDetailView'
import Keranjang from '../views/KeranjangView'
import PesananSukses from '../views/PesananSuksesView'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import EntryView from '../views/EntryView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFoundView
  },
  {
    path: '/pesanan-sukses',
    name: 'pesananSukses',
    component: PesananSukses
  },
  {
    path: '/keranjang',
    name: 'keranjang',
    component: Keranjang
  },
  {
    path: '/foods',
    name: 'foods',
    component: FoodsView
  },
  {
    path: '/foods/:id',
    name: 'FoodsDetail',
    component: FoodsDetail
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/:clientToken/:meja?',
    name: 'entry',
    component: EntryView
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'entry' || to.name === 'notFound') {
    next()
    return
  }
  try {
    const raw = localStorage.getItem('personal')
    const personal = raw ? JSON.parse(raw) : null
    if (!personal || !personal.clientToken) {
      next({ path: '/404', name: 'notFound' })
      return
    }
  } catch (e) {
    next({ path: '/404', name: 'notFound' })
    return
  }
  next()
})

export default router
